import styled from 'styled-components'

export const Inner = styled.span.attrs({ className: `theme-tags-typography-bodyM-button` })`
  color: inherit;
  display: block;
  white-space: nowrap;

  // these two rows the little hacky way to have correct gap between progress and icons
  position: relative;
  min-width: 44px;
`

const Box = styled.button`
  cursor: pointer;
  min-width: 96px;
  border: none;
  height: var(--theme-size-buttonsHeight-middle);
  padding-left: var(--theme-space-padding-button-middle);
  padding-right: var(--theme-space-padding-button-middle);
  border-radius: var(--theme-borderRadius-default);

  /* figma use border name, but actually, this look like outline, so use outline, except border */
  outline: solid var(--theme-colors-global-general-transparent) var(--theme-borderWidth-strokeM);

  transition:
    background 0.15s,
    color 0.15s,
    outline 0.15s,
    box-shadow 0.15s,
    border 0.15s;
`

export const Primary = styled(Box)`
  background-color: var(--theme-colors-theme-brand-primary);
  color: var(--theme-colors-global-general-main);

  &:focus-visible {
    background-color: var(--theme-colors-theme-brand-darker);
    outline-color: var(--theme-colors-global-grey-grey500);
    box-shadow: var(--theme-boxShadows-offset-offset100Y4);
  }

  &:hover {
    background-color: var(--theme-colors-theme-brand-darker);
    box-shadow: var(--theme-boxShadows-offset-offset100Y4);
  }

  &:active {
    background-color: var(--theme-colors-theme-brand-darkest);
    box-shadow: none;
  }

  &:disabled {
    background-color: var(--theme-colors-global-grey-grey300);
    color: var(--theme-colors-global-grey-grey500);
    cursor: not-allowed;
    box-shadow: none;
  }
`

export const PrimaryLoading = styled(Primary)`
  transition: none;
  position: relative;
  &:active,
  &:focus-visible,
  &:hover,
  &:disabled {
    cursor: wait;
    background-color: var(--theme-colors-theme-brand-primary);
    color: var(--theme-colors-global-general-main);
  }
`

export const Secondary = styled(Box)`
  background-color: var(--theme-colors-global-grey-grey100);
  color: var(--theme-colors-global-grey-grey900);

  &:focus-visible {
    outline-color: var(--theme-colors-global-grey-grey500);
    box-shadow: var(--theme-boxShadows-offset-offset100Y4);
  }

  &:hover {
    background-color: var(--theme-colors-global-grey-grey300);
    box-shadow: var(--theme-boxShadows-offset-offset100Y4);
  }

  &:active {
    background-color: var(--theme-colors-global-grey-grey700);
    color: var(--theme-colors-global-general-main);
    box-shadow: none;
  }

  &:disabled {
    background-color: var(--theme-colors-global-grey-grey300);
    color: var(--theme-colors-global-grey-grey500);
    cursor: not-allowed;
    box-shadow: none;
  }
`

export const SecondaryLoading = styled(Secondary)`
  transition: none;
  position: relative;
  &:active,
  &:focus-visible,
  &:hover,
  &:disabled {
    cursor: wait;
    background-color: var(--theme-colors-global-grey-grey100);
    color: var(--theme-colors-global-grey-grey900);
  }
`

export const Danger = styled(Box)`
  background-color: var(--theme-colors-theme-negative-main);
  color: var(--theme-colors-global-general-main);

  &:focus-visible {
    background-color: var(--theme-colors-theme-negative-darker);
    outline-color: var(--theme-colors-global-grey-grey500);
    box-shadow: var(--theme-boxShadows-offset-offset100Y4);
  }

  &:hover {
    background-color: var(--theme-colors-theme-negative-darker);
    box-shadow: var(--theme-boxShadows-offset-offset100Y4);
  }

  &:active {
    background-color: var(--theme-colors-theme-negative-darkest);
    color: var(--theme-colors-global-general-main);
    box-shadow: none;
  }

  &:disabled {
    background-color: var(--theme-colors-global-grey-grey300);
    color: var(--theme-colors-global-grey-grey500);
    cursor: not-allowed;
    box-shadow: none;
  }
`

export const DangerLoading = styled(Danger)`
  transition: none;
  position: relative;
  &:active,
  &:focus-visible,
  &:hover,
  &:disabled {
    cursor: wait;
    background-color: var(--theme-colors-theme-negative-main);
    color: var(--theme-colors-global-general-main);
  }
`

export const InheritWhite = styled(Box)`
  border: 2px solid var(--theme-colors-global-general-main);
  background: none;
  color: var(--theme-colors-global-general-main);

  &:focus-visible {
    outline-color: var(--theme-colors-theme-positive-darkest);
    box-shadow: var(--theme-boxShadows-offset-offset100Y4);
  }

  &:hover {
    border-color: var(--theme-colors-theme-positive-darker);
  }

  &:active {
    border-color: var(--theme-colors-theme-positive-darker);
    color: var(--theme-colors-theme-positive-darkest);
    box-shadow: none;
  }

  &:disabled {
    background-color: var(--theme-colors-global-grey-grey300);
    color: var(--theme-colors-global-grey-grey500);
    cursor: not-allowed;
    border: none;
    box-shadow: none;
  }
`

export const InheritWhiteLoading = styled(InheritWhite)`
  transition: none;
  position: relative;
  &:active,
  &:focus-visible,
  &:hover,
  &:disabled {
    cursor: wait;
    border: 2px solid var(--theme-colors-global-general-main);
    background: none;
    color: var(--theme-colors-global-general-main);
  }
`

export const BoxTertiary = styled.button<{ disabled?: boolean }>`
  cursor: pointer;
  min-width: 96px;

  border: 2px solid var(--theme-colors-theme-brand-darker);
  background-color: var(--theme-colors-global-general-main);
  color: var(--theme-colors-theme-brand-darker);
  outline: 2px solid var(--theme-colors-global-general-transparent);

  height: var(--theme-size-buttonsHeight-middle);
  padding-left: 18px;
  padding-right: 18px;

  display: inline-flex;
  gap: 8px;
  align-items: center;

  border-radius: var(--theme-borderRadius-default);

  justify-content: center;

  transition:
    background-color 0.15s,
    border-color 0.15s,
    color 0.15s,
    outline-color 0.15s,
    box-shadow 0.15s;

  &:focus-visible {
    color: var(--theme-colors-theme-brand-darkest);
    outline-color: var(--theme-colors-global-grey-grey500);
    box-shadow: var(--theme-boxShadows-offset-offset100Y4);
  }

  &:hover {
    border-color: var(--theme-colors-theme-brand-primary);
    color: var(--theme-colors-theme-brand-primary);
    box-shadow: var(--theme-boxShadows-offset-offset100Y4);
  }

  &:active {
    border-color: var(--theme-colors-theme-brand-darkest);
    color: var(--theme-colors-theme-brand-darkest);
  }

  &:disabled {
    border-color: var(--theme-colors-global-grey-grey500);
    color: var(--theme-colors-global-grey-grey500);
    cursor: not-allowed;
    box-shadow: none;
  }
`

export const BoxTertiaryLoading = styled(BoxTertiary)`
  transition: none;
  &:active,
  &:focus-visible,
  &:hover,
  &:disabled {
    cursor: wait;
    border: 2px solid var(--theme-colors-theme-brand-darker);
    background-color: var(--theme-colors-global-general-main);
    color: var(--theme-colors-theme-brand-darker);
    outline-width: var(--theme-borderWidth-strokeNone);
    box-shadow: var(--theme-boxShadows-none-shadowNone);
  }
`
